import { render, staticRenderFns } from "./componentsPatchRoleDialog.vue?vue&type=template&id=2ce20ee0&scoped=true"
import script from "./componentsPatchRoleDialog.vue?vue&type=script&lang=js"
export * from "./componentsPatchRoleDialog.vue?vue&type=script&lang=js"
import style0 from "./componentsPatchRoleDialog.vue?vue&type=style&index=0&id=2ce20ee0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce20ee0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ce20ee0')) {
      api.createRecord('2ce20ee0', component.options)
    } else {
      api.reload('2ce20ee0', component.options)
    }
    module.hot.accept("./componentsPatchRoleDialog.vue?vue&type=template&id=2ce20ee0&scoped=true", function () {
      api.rerender('2ce20ee0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/siteSetting/componentTeamMembers/componentsPatchRoleDialog.vue"
export default component.exports